import {
  HeightSize,
  Skeleton,
} from '@delmonicos/shared-design-system-react/src/components/skeleton/skeleton';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';

export const InvoiceDetailsLoadingView = (): React.JSX.Element => {
  return (
    <Stack gap={GapEnum.L} flex={1}>
      <Stack gap={GapEnum.L} flex={1} direction="column">
        <Skeleton flex={1} heightSize={HeightSize.Full} />
        <Skeleton flex={1} heightSize={HeightSize.Full} />
      </Stack>
      <Stack gap={GapEnum.L} flex={1}>
        <Skeleton flex={1} heightSize={HeightSize.Full} />
      </Stack>
    </Stack>
  );
};
